import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

const fmt = d => (d ? new Date(String(d).replace(' ', 'T') + 'Z').toLocaleString('he-IL', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Jerusalem' }) : '');

// Opened from the SMS link after the tenant logs in: the answers of the managers to his messages.
export default function TenantReplies() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  const [error, setError] = useState('');
  const phone = localStorage.getItem('tenantPhone') || '';
  const token = localStorage.getItem('tenantToken');
  const name = (localStorage.getItem('tenantName') || '').trim().split(/\s+/)[0];

  useEffect(() => {
    if (!token || !phone) { navigate('/portal'); return; }
    const headers = { Authorization: 'Bearer ' + token };
    api.get('/portal/tenant-replies?phone=' + encodeURIComponent(phone), { headers })
      .then(r => { setItems(r.data || []); api.post('/portal/tenant-replies/seen', { phone }, { headers }).catch(() => {}); })
      .catch(() => setError('לא הצלחנו לטעון את התשובות. נסו להיכנס שוב.'));
  }, []); // eslint-disable-line

  const box = { background: 'white', borderRadius: 14, padding: '16px 18px', boxShadow: '0 1px 4px rgba(0,0,0,.08)', marginBottom: 14 };
  return (
    <div style={{ minHeight: '100vh', background: '#f3f4f6', direction: 'rtl', padding: '24px 16px' }}>
      <div style={{ maxWidth: 520, margin: '0 auto' }}>
        <h1 style={{ fontSize: '1.4rem', color: '#1f2937', margin: '0 0 6px' }}>{name ? 'שלום ' + name : 'שלום'}, יש תשובה להודעה שלך</h1>
        <p style={{ color: '#6b7280', marginTop: 0, marginBottom: 18 }}>התשובות של מנהלי הפרויקט להודעות ששלחת באזור האישי.</p>
        {error && <div style={{ ...box, color: '#b91c1c' }}>{error}</div>}
        {items === null && !error && <div style={{ ...box, color: '#6b7280' }}>טוען...</div>}
        {items && items.length === 0 && <div style={{ ...box, color: '#6b7280' }}>אין תשובות חדשות.</div>}
        {(items || []).map(m => (
          <div key={m.id} style={box}>
            <div style={{ fontSize: '0.78rem', color: '#9ca3af', marginBottom: 4 }}>ההודעה שלך · {fmt(m.created_at)}</div>
            <div style={{ color: '#4b5563', background: '#f9fafb', borderRadius: 10, padding: '10px 12px', whiteSpace: 'pre-wrap', marginBottom: 12 }}>{m.message}</div>
            <div style={{ fontSize: '0.78rem', color: '#1a4a8a', fontWeight: 700, marginBottom: 4 }}>התשובה{m.reply_by ? ' מ' + m.reply_by : ''} · {fmt(m.replied_at)}</div>
            <div style={{ color: '#111827', lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>{m.reply_text}</div>
          </div>
        ))}
        <button onClick={() => navigate('/tenant-projects')} style={{ width: '100%', padding: 13, border: 'none', borderRadius: 12, background: '#1a4a8a', color: 'white', fontWeight: 700, fontSize: '1rem', cursor: 'pointer' }}>המשך לאזור האישי</button>
      </div>
    </div>
  );
}
